module.exports = {
          srcSet: __webpack_public_path__ + "beb586f490e9b935b5ea6c1849e24aac-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "beb586f490e9b935b5ea6c1849e24aac-24.png",width: 24,height: 25}],
          src: __webpack_public_path__ + "beb586f490e9b935b5ea6c1849e24aac-24.png",
          toString:function(){return __webpack_public_path__ + "beb586f490e9b935b5ea6c1849e24aac-24.png"},
          
          width: 24,
          height: 25
        }